<template>
  <div class="toggle-btn mt-1" @click="toggle">
    <div class="thing-container">
      <div class="thing" :class="{ active: modelValue }">
        <i v-if="modelValue" class="bi bi-check2"></i>
      </div>
    </div>
    <div class="text-container">
    <div class="toggle-text">
      {{ text }}
    </div>
    <div class="toggle-subtitle text_sec">
      {{subtitle}}
    </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ToggleButtonBigger",

  props: {
    text: { type: String, required: true },
    subtitle: { type: String, required: false },
    modelValue: { type: Boolean, default: false }
  },

  methods: {
    toggle() {
      this.$emit("update:modelValue", !this.modelValue);
    }
  }
};
</script>

<style scoped>
.text-container{
  display: block;
}
.toggle-btn{
  display: flex;
  align-items: center;
  cursor: pointer;
}

.thing-container{
  width: 2.5rem;
  height: 2.5rem;
  margin-right: 8px;
  flex-shrink: 0;
}

.thing{
  width: 100%;
  height: 100%;
  border-radius: 50%;
  border: 2px solid #555;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  color: white;
  transition: 0.2s;
}

.thing i {
  margin-top: -1px;
  margin-left: -1px;
}

.thing.active{
  background-color: #262626;
}

.toggle-text{
  font-size: 1rem;
}
</style>
